import store from '@/state/store';
import { handleError } from '@/actions/common';
import { Profile, User } from '@bimdata/definitions/dto';
import userSlice from '@/state/user.slice';
import { getAvatar } from '@/api/user';
import { RequestStatus } from '@/contracts';
import { ApiError } from '@bimdata/client';

export default async function ({ id, avatar }: User | Profile): Promise<void> {
  if (!avatar) {
    store.dispatch(userSlice.actions.avatarIdle({
      userId: id,
      source: null
    }));
    return;
  }

  const state = store.getState();
  if (state.user.avatars[id]?.status === RequestStatus.BUSY) {
    return;
  }

  try {
    store.dispatch(userSlice.actions.avatarBusy(id));
    const source = await getAvatar(id, avatar);
    store.dispatch(userSlice.actions.avatarIdle({
      userId: id,
      source
    }));
  } catch (error) {
    if (error instanceof ApiError && error.code === 403) {
      store.dispatch(userSlice.actions.avatarIdle({
        userId: id,
        source: null
      }));
      return;
    }

    store.dispatch(userSlice.actions.avatarError(id));
    handleError(error);
  }
};